<div *ngIf="postedFlightFacade.postedFlightSkeletonLoading$ | async">Loading...</div>
<div *ngIf="postedFlightFacade.postedFlightSkeletonLoaded$ | async">
  <div *ngIf="postedFlightFacade.postedFlightSkeleton$ | async as postedFlightSkeleton">
    <mat-accordion>
      <!--Leg Details-->
      <mat-expansion-panel
        (opened)="postedFlightFacade.loadLegDetailAudit(postedFlightSkeleton.postedFlightId)"
      >
        <mat-expansion-panel-header>Leg Details</mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <sd-portal-audit-detail-list
            [loading]="postedFlightFacade.postedFlightAuditLoading$ | async"
            [loaded]="postedFlightFacade.postedFlightAuditLoaded$ | async"
            [audits]="postedFlightFacade.postedFlightAudit$ | async"
            [noAuditsMessage]="'No audit records for this posted flight'"
            (nextPage)="
              postedFlightFacade.loadNextLegDetailAuditPage(postedFlightSkeleton.postedFlightId)
            "
          ></sd-portal-audit-detail-list>
        </ng-template>
      </mat-expansion-panel>
      <!--Fuel-->
      <mat-expansion-panel
        (opened)="postedFlightFacade.loadPostedFlightFuelAudit(postedFlightSkeleton.postedFlightId)"
      >
        <mat-expansion-panel-header>Fuel</mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <sd-portal-audit-detail-list
            [loading]="postedFlightFacade.postedFlightFuelAuditLoading$ | async"
            [loaded]="postedFlightFacade.postedFlightFuelAuditLoaded$ | async"
            [audits]="postedFlightFacade.postedFlightFuelAudit$ | async"
            [noAuditsMessage]="'No audit records for fuel'"
            (nextPage)="
              postedFlightFacade.loadNextPagePostedFlightFuelAudit(
                postedFlightSkeleton.postedFlightId
              )
            "
          ></sd-portal-audit-detail-list>
        </ng-template>
      </mat-expansion-panel>
      <!-- airframe/engine cycle -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>Airframe/Engine(s)</mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <mat-accordion>
            <mat-expansion-panel
              (opened)="
                postedFlightFacade.loadAirFrameLandingsAudit(postedFlightSkeleton.postedFlightId)
              "
            >
              <mat-expansion-panel-header>AirFrame</mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="postedFlightFacade.airFrameLandingsAuditLoading$ | async"
                  [loaded]="postedFlightFacade.airFrameLandingsAuditLoaded$ | async"
                  [audits]="postedFlightFacade.airFrameLandingsAudit$ | async"
                  [noAuditsMessage]="'No audit records for the Airframe landings'"
                  (nextPage)="
                    postedFlightFacade.loadNextPageAirFrameLandingsAudit(
                      postedFlightSkeleton.postedFlightId
                    )
                  "
                ></sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>
            <mat-expansion-panel
              *ngFor="let engine of postedFlightSkeleton.postedFlightEngines"
              (opened)="postedFlightFacade.loadEngineCyclesAudit(engine.postedFlightEngineId)"
            >
              <mat-expansion-panel-header>{{ engine.name }}</mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="postedFlightFacade.engineCyclesAuditLoading$ | async"
                  [loaded]="postedFlightFacade.engineCyclesAuditLoaded$ | async"
                  [audits]="postedFlightFacade.engineCyclesAudit$ | async"
                  [noAuditsMessage]="'No audit records for this engine cycles'"
                  (nextPage)="
                    postedFlightFacade.loadNextPageEngineCyclesAudit(engine.postedFlightEngineId)
                  "
                ></sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
      <!--Crew-->
      <mat-expansion-panel
        *ngIf="
          postedFlightSkeleton.flightCrewMembers &&
          postedFlightSkeleton.flightCrewMembers.length > 0
        "
      >
        <mat-expansion-panel-header>Crew</mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <mat-accordion>
            <mat-expansion-panel
              *ngFor="let flightCrewMember of postedFlightSkeleton.flightCrewMembers"
              (opened)="
                postedFlightFacade.loadFlightCrewMemberAudit(flightCrewMember.flightCrewMemberId)
              "
            >
              <mat-expansion-panel-header>
                {{ flightCrewMember.name }}
                <span *ngIf="flightCrewMember.isDeleted">&nbsp;(Deleted)</span>
              </mat-expansion-panel-header>

              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="postedFlightFacade.flightCrewMemberAuditLoading$ | async"
                  [loaded]="postedFlightFacade.flightCrewMemberAuditLoaded$ | async"
                  [audits]="postedFlightFacade.flightCrewMemberAudit$ | async"
                  [noAuditsMessage]="'No audit records for this crew member'"
                  (nextPage)="
                    postedFlightFacade.loadNextPageFlightCrewMemberAuditPage(
                      flightCrewMember.flightCrewMemberId
                    )
                  "
                ></sd-portal-audit-detail-list>

                <mat-accordion>
                  <mat-expansion-panel
                    *ngIf="flightCrewMember.crewMemberDutyId"
                    (opened)="
                      postedFlightFacade.loadCrewMemberDutyAudit(flightCrewMember.crewMemberDutyId)
                    "
                  >
                    <mat-expansion-panel-header>Duty Times</mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                      <sd-portal-audit-detail-list
                        [loading]="postedFlightFacade.crewMemberDutyAuditLoading$ | async"
                        [loaded]="postedFlightFacade.crewMemberDutyAuditLoaded$ | async"
                        [audits]="postedFlightFacade.crewMemberDutyAudit$ | async"
                        [noAuditsMessage]="'No audit records for this crew member\'s duty times'"
                        (nextPage)="
                          postedFlightFacade.loadNextPageCrewMemberDutyAudit(
                            flightCrewMember.crewMemberDutyId
                          )
                        "
                      ></sd-portal-audit-detail-list>
                    </ng-template>
                  </mat-expansion-panel>

                  <mat-expansion-panel
                    *ngIf="flightCrewMember.logbook"
                    (opened)="
                      postedFlightFacade.loadLogbookAudit(flightCrewMember.logbook.logbookId)
                    "
                  >
                    <mat-expansion-panel-header
                      >Instruments / Landings / Hold / Track</mat-expansion-panel-header
                    >
                    <ng-template matExpansionPanelContent>
                      <sd-portal-audit-detail-list
                        [loading]="postedFlightFacade.logbookAuditLoading$ | async"
                        [loaded]="postedFlightFacade.logbookAuditLoaded$ | async"
                        [audits]="postedFlightFacade.logbookAudit$ | async"
                        [noAuditsMessage]="'No audit records for this crew member\'s logbook'"
                        (nextPage)="
                          postedFlightFacade.loadNextPageLogbookAudit(
                            flightCrewMember.logbook.logbookId
                          )
                        "
                      ></sd-portal-audit-detail-list>
                    </ng-template>
                  </mat-expansion-panel>

                  <mat-expansion-panel
                    *ngIf="
                      flightCrewMember.logbook &&
                      flightCrewMember.logbook.logbookApproaches &&
                      flightCrewMember.logbook.logbookApproaches.length > 0
                    "
                  >
                    <mat-expansion-panel-header>Approaches</mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                      <mat-accordion>
                        <mat-expansion-panel
                          *ngFor="let logbookApproach of flightCrewMember.logbook.logbookApproaches"
                          (opened)="
                            postedFlightFacade.loadLogbookApproachAudit(
                              logbookApproach.logbookApproachId
                            )
                          "
                        >
                          <mat-expansion-panel-header>
                            {{
                              postedFlightFacade.getApproachTypeName(logbookApproach.approachTypeId)
                                | async
                            }}
                            <span *ngIf="logbookApproach.isDeleted">&nbsp;(Deleted)</span>
                          </mat-expansion-panel-header>

                          <ng-template matExpansionPanelContent>
                            <sd-portal-audit-detail-list
                              [loading]="postedFlightFacade.logbookApproachAuditLoading$ | async"
                              [loaded]="postedFlightFacade.logbookApproachAuditLoaded$ | async"
                              [audits]="postedFlightFacade.logbookApproachAudit$ | async"
                              [noAuditsMessage]="'No audit records for this approach'"
                              (nextPage)="
                                postedFlightFacade.loadNextPageLogbookApproachAudit(
                                  logbookApproach.logbookApproachId
                                )
                              "
                            ></sd-portal-audit-detail-list>
                          </ng-template>
                        </mat-expansion-panel>
                      </mat-accordion>
                    </ng-template>
                  </mat-expansion-panel>
                </mat-accordion>
              </ng-template>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
      <!--Additional Detail-->
      <mat-expansion-panel
        (opened)="
          postedFlightFacade.loadPostedFlightAdditionalDetailAudit(
            postedFlightSkeleton.postedFlightId
          )
        "
      >
        <mat-expansion-panel-header>Additional Detail</mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <sd-portal-audit-detail-list
            [loading]="postedFlightFacade.postedFlightAdditionalDetailAuditLoading$ | async"
            [loaded]="postedFlightFacade.postedFlightAdditionalDetailAuditLoaded$ | async"
            [audits]="postedFlightFacade.postedFlightAdditionalDetailAudit$ | async"
            [noAuditsMessage]="'No audit records for the additional detail'"
            (nextPage)="
              postedFlightFacade.loadNextPagePostedFlightAdditionalDetailAudit(
                postedFlightSkeleton.postedFlightId
              )
            "
          ></sd-portal-audit-detail-list>

          <mat-accordion>
            <mat-expansion-panel
              (opened)="postedFlightFacade.loadBusinessCategoryAudit(postedFlightSkeleton.flightId)"
            >
              <mat-expansion-panel-header>Business Category</mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="postedFlightFacade.businessCategoryAuditLoading$ | async"
                  [loaded]="postedFlightFacade.businessCategoryAuditLoaded$ | async"
                  [audits]="postedFlightFacade.businessCategoryAudit$ | async"
                  [noAuditsMessage]="'No audit records for the business category'"
                  (nextPage)="
                    postedFlightFacade.loadNextPageBusinessCategoryAudit(
                      postedFlightSkeleton.flightId
                    )
                  "
                ></sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel
              (opened)="postedFlightFacade.loadDepartmentAudit(postedFlightSkeleton.flightId)"
            >
              <mat-expansion-panel-header>Charge To</mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="postedFlightFacade.departmentAuditLoading$ | async"
                  [loaded]="postedFlightFacade.departmentAuditLoaded$ | async"
                  [audits]="postedFlightFacade.departmentAudit$ | async"
                  [noAuditsMessage]="'No audit records for the charge to'"
                  (nextPage)="
                    postedFlightFacade.loadNextPageDepartmentAudit(postedFlightSkeleton.flightId)
                  "
                ></sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>

            <!-- requestor/planner/approver -->
            <mat-expansion-panel
              *ngIf="
                postedFlightSkeleton.flightBusinessPersons &&
                postedFlightSkeleton.flightBusinessPersons.length > 0
              "
            >
              <mat-expansion-panel-header
                >Requestors / Planners / Approvers</mat-expansion-panel-header
              >
              <ng-template matExpansionPanelContent>
                <mat-accordion>
                  <mat-expansion-panel
                    *ngFor="let flightBusinessPerson of postedFlightSkeleton.flightBusinessPersons"
                    (opened)="
                      postedFlightFacade.loadFlightBusinessPersonAudit(
                        flightBusinessPerson.flightBusinessPersonId
                      )
                    "
                  >
                    <mat-expansion-panel-header>
                      {{ flightBusinessPerson.name }}
                      <span *ngIf="flightBusinessPerson.isDeleted">&nbsp;(Deleted)</span>
                    </mat-expansion-panel-header>

                    <ng-template matExpansionPanelContent>
                      <sd-portal-audit-detail-list
                        [loading]="postedFlightFacade.flightBusinessPersonAuditLoading$ | async"
                        [loaded]="postedFlightFacade.flightBusinessPersonAuditLoaded$ | async"
                        [audits]="postedFlightFacade.flightBusinessPersonAudit$ | async"
                        [noAuditsMessage]="'No audit records for this business person'"
                        (nextPage)="
                          postedFlightFacade.loadNextPageFlightBusinessPersonAudit(
                            flightBusinessPerson.flightBusinessPersonId
                          )
                        "
                      ></sd-portal-audit-detail-list>
                    </ng-template>
                  </mat-expansion-panel>
                </mat-accordion>
              </ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel
              (opened)="
                postedFlightFacade.loadVORCheckDataAudit(postedFlightSkeleton.aircraftProfileId)
              "
            >
              <mat-expansion-panel-header>VOR Check</mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="postedFlightFacade.vorcheckDataAuditLoading$ | async"
                  [loaded]="postedFlightFacade.vorcheckDataAuditLoaded$ | async"
                  [audits]="postedFlightFacade.vorcheckDataAudit$ | async"
                  [noAuditsMessage]="'No audit records for VOR Check'"
                  (nextPage)="
                    postedFlightFacade.loadNextPageVORCheckDataAudit(
                      postedFlightSkeleton.postedFlightId
                    )
                  "
                ></sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>

      <!--Passengers-->
      <mat-expansion-panel
        *ngIf="
          postedFlightSkeleton.flightPassengers && postedFlightSkeleton.flightPassengers.length > 0
        "
      >
        <mat-expansion-panel-header>Passengers</mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <mat-accordion>
            <mat-expansion-panel
              *ngFor="let flightPassenger of postedFlightSkeleton.flightPassengers"
              (opened)="
                postedFlightFacade.loadFlightPassengerAudit(flightPassenger.flightPassengerId)
              "
            >
              <mat-expansion-panel-header>
                {{ flightPassenger.name }}
                <span *ngIf="flightPassenger.isDeleted">&nbsp;(Deleted)</span>
              </mat-expansion-panel-header>

              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="postedFlightFacade.flightPassengerAuditLoading$ | async"
                  [loaded]="postedFlightFacade.flightPassengerAuditLoaded$ | async"
                  [audits]="postedFlightFacade.flightPassengerAudit$ | async"
                  [noAuditsMessage]="'No audit records for this passeger'"
                  (nextPage)="
                    postedFlightFacade.loadNextPageFlightPassengerAudit(
                      flightPassenger.flightPassengerId
                    )
                  "
                ></sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
      <!--Expenses-->
      <mat-expansion-panel
        *ngIf="postedFlightSkeleton.expenses && postedFlightSkeleton.expenses.length > 0"
      >
        <mat-expansion-panel-header>Expenses</mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <mat-accordion>
            <mat-expansion-panel
              *ngFor="let expense of postedFlightSkeleton.expenses"
              (opened)="postedFlightFacade.loadExpenseAudit(expense.expenseId)"
            >
              <mat-expansion-panel-header>
                {{
                  postedFlightFacade.getExpenseCategoryTypeName(expense.expenseCategoryId) | async
                }}
                <span *ngIf="expense.isDeleted">&nbsp;(Deleted)</span>
              </mat-expansion-panel-header>

              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="postedFlightFacade.expenseAuditLoading$ | async"
                  [loaded]="postedFlightFacade.expenseAuditLoaded$ | async"
                  [audits]="postedFlightFacade.expenseAudit$ | async"
                  [noAuditsMessage]="'No audit records for this expense'"
                  (nextPage)="postedFlightFacade.loadNextPageExpenseAudit(expense.expenseId)"
                >
                </sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
      <!--APU/Custom Components-->
      <mat-expansion-panel
        *ngIf="
          postedFlightSkeleton.postedFlightComponents &&
          postedFlightSkeleton.postedFlightComponents.length > 0
        "
      >
        <mat-expansion-panel-header>APU/Custom Component(s)</mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <mat-accordion>
            <mat-expansion-panel
              *ngFor="let component of postedFlightSkeleton.postedFlightComponents"
              (opened)="
                postedFlightFacade.loadPostedFlightComponentAudit(component.postedFlightComponentId)
              "
            >
              <mat-expansion-panel-header>
                {{ component.name }} <span *ngIf="component.isDeleted">&nbsp;(Deleted)</span>
              </mat-expansion-panel-header>

              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="postedFlightFacade.postedFlightComponentAuditLoading$ | async"
                  [loaded]="postedFlightFacade.postedFlightComponentAuditLoaded$ | async"
                  [audits]="postedFlightFacade.postedFlightComponentAudit$ | async"
                  [noAuditsMessage]="'No audit records for this apu/component'"
                  (nextPage)="
                    postedFlightFacade.loadNextPagePostedFlightComponentAudit(
                      component.postedFlightComponentId
                    )
                  "
                ></sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
      <!--Oils & Fluids & Fuel Uplift-->
      <mat-expansion-panel>
        <mat-expansion-panel-header>Oils & Fluids & Fuel Uplift</mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <mat-accordion>
            <mat-expansion-panel
              *ngFor="let engine of postedFlightSkeleton.postedFlightEngines"
              (opened)="postedFlightFacade.loadEngineOilFluidAudit(engine.postedFlightEngineId)"
            >
              <mat-expansion-panel-header>{{ engine.name }}</mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="postedFlightFacade.engineOilFluidAuditLoading$ | async"
                  [loaded]="postedFlightFacade.engineOilFluidAuditLoaded$ | async"
                  [audits]="postedFlightFacade.engineOilFluidAudit$ | async"
                  [noAuditsMessage]="'No audit records for this engine\'s oils/fluids'"
                  (nextPage)="
                    postedFlightFacade.loadNextPageEngineOilFluidAudit(engine.postedFlightEngineId)
                  "
                ></sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel
              (opened)="postedFlightFacade.loadOilFluidAudit(postedFlightSkeleton.postedFlightId)"
            >
              <mat-expansion-panel-header>Hydraulics</mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="postedFlightFacade.oilFluidAuditLoading$ | async"
                  [loaded]="postedFlightFacade.oilFluidAuditLoaded$ | async"
                  [audits]="postedFlightFacade.oilFluidAudit$ | async"
                  [noAuditsMessage]="'No audit records for the hydraulics'"
                  (nextPage)="
                    postedFlightFacade.loadNextPageOilFluidAudit(
                      postedFlightSkeleton.postedFlightId
                    )
                  "
                ></sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel
              *ngFor="let component of postedFlightSkeleton.postedFlightComponents"
              (opened)="
                postedFlightFacade.loadComponentOilFluidAudit(component.postedFlightComponentId)
              "
            >
              <mat-expansion-panel-header>{{ component.name }}</mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="postedFlightFacade.componentOilFluidAuditLoading$ | async"
                  [loaded]="postedFlightFacade.componentOilFluidAuditLoaded$ | async"
                  [audits]="postedFlightFacade.componentOilFluidAudit$ | async"
                  [noAuditsMessage]="'No audit records for this apu/component\'s oils/fluids'"
                  (nextPage)="
                    postedFlightFacade.loadNextPageComponentOilFluidAudit(
                      component.postedFlightComponentId
                    )
                  "
                ></sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel
              (opened)="postedFlightFacade.loadFuelUpliftAudit(postedFlightSkeleton.postedFlightId)"
            >
              <mat-expansion-panel-header>Fuel Uplift</mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="postedFlightFacade.fuelUpliftAuditLoading$ | async"
                  [loaded]="postedFlightFacade.fuelUpliftAuditLoaded$ | async"
                  [audits]="postedFlightFacade.fuelUpliftAudit$ | async"
                  [noAuditsMessage]="'No audit records for the fuel uplift'"
                  (nextPage)="
                    postedFlightFacade.loadNextPageFuelUpliftAudit(
                      postedFlightSkeleton.postedFlightId
                    )
                  "
                ></sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
      <!--De/Anti-Ice-->
      <mat-expansion-panel
        (opened)="
          postedFlightFacade.loadPostedFlightDeAntiIceAudit(postedFlightSkeleton.postedFlightId)
        "
      >
        <mat-expansion-panel-header>De/Anti-Ice</mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <sd-portal-audit-detail-list
            [loading]="postedFlightFacade.postedFlightDeAntiIceAuditLoading$ | async"
            [loaded]="postedFlightFacade.postedFlightDeAntiIceAuditLoaded$ | async"
            [audits]="postedFlightFacade.postedFlightDeAntiIceAudit$ | async"
            [noAuditsMessage]="'No audit records for de/anti-ice'"
            (nextPage)="
              postedFlightFacade.loadNextPagePostedFlightDeAntiIceAudit(
                postedFlightSkeleton.postedFlightId
              )
            "
          ></sd-portal-audit-detail-list>
        </ng-template>
      </mat-expansion-panel>
      <!--Notes-->
      <mat-expansion-panel
        (opened)="
          postedFlightFacade.loadPostedFlightNotesAudit(postedFlightSkeleton.postedFlightId)
        "
      >
        <mat-expansion-panel-header>Notes</mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <sd-portal-audit-detail-list
            [loading]="postedFlightFacade.postedFlightNotesAuditLoading$ | async"
            [loaded]="postedFlightFacade.postedFlightNotesAuditLoaded$ | async"
            [audits]="postedFlightFacade.postedFlightNotesAudit$ | async"
            [noAuditsMessage]="'No audit records for notes'"
            (nextPage)="
              postedFlightFacade.loadNextPagePostedFlightNotesAudit(
                postedFlightSkeleton.postedFlightId
              )
            "
          ></sd-portal-audit-detail-list>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>E-Signature(s)</mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <mat-accordion>
            <!--PreFlight User eSignatures-->
            <mat-expansion-panel
              (opened)="
                postedFlightFacade.loadPreFlightChecklistUserESignaturesAudit(
                  postedFlightSkeleton.postedFlightId
                )
              "
            >
              <mat-expansion-panel-header>Pre-Flight Checklists</mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="
                    postedFlightFacade.preFlightChecklistUserESignaturesAuditLoading$ | async
                  "
                  [loaded]="
                    postedFlightFacade.preFlightChecklistUserESignaturesAuditLoaded$ | async
                  "
                  [audits]="postedFlightFacade.preFlightChecklistUserESignaturesAudit$ | async"
                  [noAuditsMessage]="'No audit records for pre-flight checklists e-signatures'"
                  (nextPage)="
                    postedFlightFacade.loadNextPagePreFlightChecklistUserESignaturesAudit(
                      postedFlightSkeleton.postedFlightId
                    )
                  "
                ></sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>
            <!--Posted Flight User eSignatures-->
            <mat-expansion-panel
              (opened)="
                postedFlightFacade.loadPostedFlightChecklistUserESignaturesAudit(
                  postedFlightSkeleton.postedFlightId
                )
              "
            >
              <mat-expansion-panel-header>Post-Flight Checklists</mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="
                    postedFlightFacade.postedFlightChecklistUserESignaturesAuditLoading$ | async
                  "
                  [loaded]="
                    postedFlightFacade.postedFlightChecklistUserESignaturesAuditLoaded$ | async
                  "
                  [audits]="postedFlightFacade.postedFlightChecklistUserESignaturesAudit$ | async"
                  [noAuditsMessage]="'No audit records for posted flight checklists e-signatures'"
                  (nextPage)="
                    postedFlightFacade.loadNextPagePostedFlightChecklistUserESignaturesAudit(
                      postedFlightSkeleton.postedFlightId
                    )
                  "
                ></sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>
            <!--Flight Log User eSignatures-->
            <mat-expansion-panel
              (opened)="
                postedFlightFacade.loadFlightLogUserESignaturesAudit(
                  postedFlightSkeleton.postedFlightId
                )
              "
            >
              <mat-expansion-panel-header>Flight Logs</mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="postedFlightFacade.flightLogUserESignaturesAuditLoading$ | async"
                  [loaded]="postedFlightFacade.flightLogUserESignaturesAuditLoaded$ | async"
                  [audits]="postedFlightFacade.flightLogUserESignaturesAudit$ | async"
                  [noAuditsMessage]="'No audit records for flight logs e-signatures'"
                  (nextPage)="
                    postedFlightFacade.loadNextPageFlightLogUserESignaturesAudit(
                      postedFlightSkeleton.postedFlightId
                    )
                  "
                ></sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>
            <!--Squawk User eSignatures-->
            <mat-expansion-panel
              (opened)="
                postedFlightFacade.loadSquawkUserESignaturesAudit(
                  postedFlightSkeleton.postedFlightId
                )
              "
            >
              <mat-expansion-panel-header>Squawks/Discrepancies</mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <sd-portal-audit-detail-list
                  [loading]="postedFlightFacade.squawkUserESignaturesAuditLoading$ | async"
                  [loaded]="postedFlightFacade.squawkUserESignaturesAuditLoaded$ | async"
                  [audits]="postedFlightFacade.squawkUserESignaturesAudit$ | async"
                  [noAuditsMessage]="'No audit records for squawks e-signatures'"
                  (nextPage)="
                    postedFlightFacade.loadNextPageSquawkUserESignaturesAudit(
                      postedFlightSkeleton.postedFlightId
                    )
                  "
                ></sd-portal-audit-detail-list>
              </ng-template>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
